import { render, staticRenderFns } from "./balance-summary.vue?vue&type=template&id=2f645a2c&scoped=true"
import script from "./balance-summary.vue?vue&type=script&lang=js"
export * from "./balance-summary.vue?vue&type=script&lang=js"
import style0 from "./balance-summary.vue?vue&type=style&index=0&id=2f645a2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f645a2c",
  null
  
)

export default component.exports